import $ajax from 'axios'
// import {Message} from 'element-ui'
import {hideLoad} from '@/tools/loading.js'

/*
  得到七牛上传服务临时token，当前设置为5分钟内有效。正常使用场景为每次上传资源前实时获取，而不是保存下来一直使用 get /cms/GetQiniuUploadToken
  suffix str 文件后缀
*/

function getQiNiuToken (suffix, hashCode, fn) {
  $ajax.get(`v2/cms/GetQiniuUploadToken?suffix=${suffix}&hashCode=${hashCode}`).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      try {
        let data = JSON.parse(res.data.data)
        fn && fn(data)
      } catch (e) {
      }
    }
  }).catch(err => {
    hideLoad()
  })
}

export {getQiNiuToken}



// WEBPACK FOOTER //
// ./src/apis/qiniu.js